import { EnExpirationType } from '../../enum/en-expiration-type';

export interface IGenerateToken {
    expiration: number;
    enExpirationType: EnExpirationType;
}